import { AppEvent } from 'types/appEvent';
import { createReducer } from 'utils/reducer/reducerUtils';
import { ProdStackManagerStep } from 'types/prodStakManagerTypes';

export const reduceToNextProdStackManagerCurrentStep = createReducer<
  ProdStackManagerStep,
  AppEvent
>((prev, event) => {
  switch (event.name) {
    case 'ProdStackManager__DataRecieved': {
      if (event.data.prodStackInfo) {
        return 2;
      }

      return prev;
    }
    case 'ProdStackManager__BackActionPressed':
      switch (prev) {
        case 1:
          return 0;
        case 2:
          return 1;
        default:
          return prev;
      }
    case 'ProdStackManager__StepSubmitSucceed':
      switch (prev) {
        case 0:
          return 1;
        case 1:
          return 2;
        default:
          return prev;
      }
    case 'ProdStackManager__TryOnceAgain':
      return 0;
    default:
      return prev;
  }
});
